import { render, staticRenderFns } from "./LoaderSpin.vue?vue&type=template&id=7157f5b3&scoped=true&"
import script from "./LoaderSpin.vue?vue&type=script&lang=js&"
export * from "./LoaderSpin.vue?vue&type=script&lang=js&"
import style0 from "./LoaderSpin.vue?vue&type=style&index=0&id=7157f5b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7157f5b3",
  null
  
)

export default component.exports